<template>
  <v-card>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subheading">Stock Balance</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text v-if="isLoading">
      <v-progress-linear
        size="70"
        color="pink"
        width="7"
        indeterminate="indeterminate"
      ></v-progress-linear>
    </v-card-text>
    <v-list class="list-500" v-if="!isLoading">
      <template v-for="(row, index) in stockCount">
        <v-list-tile :key="row.id" avatar ripple @click="$router.push({path: `/inventory/product/list?search=${row.productDetail}`})">
          <v-list-tile-content>
            <v-list-tile-title>{{ row.productDetail }}</v-list-tile-title> </v-list-tile-content
          ><v-list-tile-action>
            <span>{{row.stock}}</span>
            
          </v-list-tile-action>
        </v-list-tile>
        <v-divider v-if="(index + 1) < stockCount.length" :key="index"> </v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import inventoryService from "../service.js";

export default {
  data() {
    return {
      stockCount: [],
      isLoading: true,
    };
  },
  methods: {
    getStockCount() {
      inventoryService.getStockCount().then(result => {
        this.stockCount = result.data
        this.isLoading = false;
      });
    }
  },
  mounted() {
    this.getStockCount();
  }
};
</script>

<style scoped></style>
